import axios, { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import { CenterView, RowView } from "../../../Component/style/common_style";
import Layout_user from "../../../Component/UI/Layout_user";

const Content = styled.div`
  padding: 1rem;
  padding-bottom: 4rem;
`;
const Label = styled.div`
  ${fontStyles.Bold}
  font-size: 20px;
  margin: 1rem 0;
`;
const OrderList = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0rem 1.5rem;
  margin-bottom: 2rem;
  div.orderitem {
    padding: 1.5rem 0rem;
    border-top: 1px solid #d9d9d9;
  }
  div.gray {
    ${fontStyles.medium}
    color: #8E8E8E;
  }
`;
const PriceBox = styled(RowView)`
  margin-bottom: 0.5rem;
  div.title {
    color: #8e8e8e;
    ${fontStyles.medium}
  }
  div.price {
    ${fontStyles.semiBold}
  }
`;
const GrayBox = styled.div`
  padding: 0.6rem 1rem;
  margin-top: 1rem;
  color: #8e8e8e;
  line-height: 22px;
  font-size: 14px;
  background-color: #f0f0f0;
  border-radius: 4px;
`;
const TotalBox = styled(RowView)`
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 2px solid #2d2d2d;
  ${fontStyles.medium}
  div.total {
    color: #ea2922;
    ${fontStyles.Bold}
    font-size: 24px;
  }
`;
const Name = styled.div`
  ${fontStyles.medium}
  margin-bottom: 0.5rem;
  &.cancel,
  &.refund {
    color: #8e8e8e;
  }
`;
const Price = styled.div`
  ${fontStyles.Bold}
  font-size: 20px;
  &.cancel,
  &.refund {
    color: #8e8e8e;
    text-decoration: line-through;
  }
`;
const Status = styled(CenterView)`
  width: 5.5rem;
  height: 2rem;
  margin-top: 0.5rem;
  ${fontStyles.medium}
  border: 1px solid #474747;
  border-radius: 8px;
  &.nonpay,
  &.refund {
    color: #8e8e8e;
    border: 1px solid #d9d9d9;
  }
  &.cancel {
    color: #eb003b;
    border: 1px solid #eb003b;
  }
`;

interface InfoList {
  option_name: null | string;
  order_cnt: number;
  order_price: number;
  order_status: string;
  product_name: string;
}

const User_Bill = () => {
  const { uid } = useParams();

  const [list, setList] = useState<InfoList[]>([]);
  const [cancelRefund, setCancelRefund] = useState(0);
  const [purchase, setPurchase] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [delivery_price, setDelivery_price] = useState(0);

  const get_statement_info = async () => {
    axios
      .get(url.Communication_url.statement_info, {
        params: { order_seq: Number(uid) },
      })
      .then((res) => {
        setList(res.data.details || []);
        setCancelRefund(res.data.cancelRefund);
        setPurchase(res.data.purchase);
        setTotalPayment(res.data.totalPayment);
        setDelivery_price(res.data.delivery_price || 0);
      })
      .catch((err) => {
        if (err instanceof AxiosError && err.response) {
          const errRes = err.response.data;
          switch (errRes?.statusCode) {
            case 401:
            case 403:
              console.log("권한부족");
              break;
            default:
              console.error(errRes);
          }
        } else {
          console.error(err);
        }
      });
  };
  useEffect(() => {
    if (Number(uid)) {
      get_statement_info();
    }
  }, []);

  const status_class = (status: string) => {
    switch (status) {
      case "미입금":
        return "nonpay";
      case "주문취소":
        return "cancel";
      case "환불처리":
        return "refund";
      default:
        return "";
    }
  };

  return (
    <Layout_user background="white">
      <Content>
        <Label>구매목록</Label>

        <OrderList>
          {list.map((data, idx) => {
            const option_name = data.option_name?.replace("&", " / ");

            return (
              <div
                style={idx === 0 ? { border: 0 } : {}}
                className="orderitem"
                key={idx}
              >
                <Name className={status_class(data.order_status)}>
                  {data.product_name}
                  {option_name && " / "}
                  {option_name}
                </Name>
                <RowView>
                  <div className="gray">수량: {data.order_cnt}개</div>
                  <Price className={status_class(data.order_status)}>
                    {data.order_price.toLocaleString()}원
                  </Price>
                </RowView>

                <Status className={status_class(data.order_status)}>
                  {data.order_status}
                </Status>
              </div>
            );
          })}
        </OrderList>

        <Label>결제 금액</Label>
        <PriceBox>
          <div className="title">구매금액</div>
          <div className="price">{purchase.toLocaleString()}원</div>
        </PriceBox>
        <PriceBox>
          <div className="title">취소/환불 금액</div>
          <div className="price" style={{ color: "#8E8E8E" }}>
            {cancelRefund !== 0 && "-"}
            {cancelRefund.toLocaleString()}원
          </div>
        </PriceBox>
        {cancelRefund !== purchase && (
          <PriceBox>
            <div className="title">택배비</div>
            <div className="price">
              {delivery_price !== 0 && "+"}
              {delivery_price.toLocaleString()}원
            </div>
          </PriceBox>
        )}

        <GrayBox>
          - 제주도,도서산간지역 추가배송료(3500원)
          <br />- 택배상자 기준초과시 배송비가 추가될 수 있습니다.
        </GrayBox>

        <TotalBox>
          <div>총 구매금액</div>
          {cancelRefund !== purchase ? (
            <div className="total">{totalPayment.toLocaleString()}원</div>
          ) : (
            <div className="total">0원</div>
          )}
        </TotalBox>
      </Content>
    </Layout_user>
  );
};

export default User_Bill;
